import { render, staticRenderFns } from "./grid-item.vue?vue&type=template&id=fa0bcedc&scoped=true"
import script from "./grid-item.vue?vue&type=script&lang=js"
export * from "./grid-item.vue?vue&type=script&lang=js"
import style0 from "./grid-item.vue?vue&type=style&index=0&id=fa0bcedc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa0bcedc",
  null
  
)

export default component.exports